module.exports = __webpack_public_path__ + "static/media/hedgy_circle.602b5579.png";